import AdminPageLoader from "components/AdminPageLoader";
import { portalPageMeta } from "layouts/Admin2/pageMeta";
import PageHeading from "admin/components/PageHeading";
import useFetchConfigs from "api/ConfigResource/useFetchConfigs";
import Admin2 from "layouts/Admin2";
import ConfigItem from "./ConfigItem";

import useAuthStore from "store/authStore";
import { Permission } from "utils/server-constants/permissions";

const Configurations = () => {
    const { hasPermissions } = useAuthStore();
    const canView = hasPermissions([Permission.ViewConfiguration]);
    const canUpdate = hasPermissions([Permission.UpdateConfiguration]);
	const { data: configs, isLoading, isError } = useFetchConfigs(Boolean(canView));

    if (!canView) return <Admin2 fullWidth><p role="status">Configuration access is unavailable with your current permissions.</p></Admin2>;
    if (isError) return <Admin2 fullWidth><p role="alert">Configurations could not be loaded. Please try again later.</p></Admin2>;


	if (isLoading) return <AdminPageLoader />;

	if (!configs || configs.length <= 0) {
		return (
			<Admin2 fullWidth>
				<div className="flex flex-col justify-center items-center h-full w-full py-32">
					<p className="text-gray-400 text-xl mb-2">No configurations found.</p>
					<p className="text-gray-500">
						Please check back later or contact support.
					</p>
				</div>
			</Admin2>
		);
	}

	return (
		<Admin2 fullWidth>
			<div className="portal-page-container">
				<div className="flex flex-col  gap-4 w-full mb-6">
					<PageHeading title="Configuration" description={portalPageMeta("/configurations").description} />
					<p className="text-gray-500 text-base max-w-2xl font-light">
						Manage and review application configuration values. These settings
						control various aspects of the application. Changes may affect
						system behavior.
					</p>
				</div>

				{!canUpdate && <p role="status">You have read access. Editing requires configuration update permission.</p>}
                <div className="portal-settings-grid">
					{configs.map((config) => (
						<ConfigItem
							key={config.id}
							id={config.id}
							name={config.name}
							label={config.label}
							value={config.value}
							dataType={config.data_type}
                            canUpdate={Boolean(canUpdate) && config.mutable}
                            sensitive={config.sensitive}
                            isSet={config.is_set}
						/>
					))}
				</div>
			</div>
		</Admin2>
	);
};

export default Configurations;
